const mutations = {
    SET_ERROR_LEGAL(state, payload) {
        state.error = payload;
    }
};

export default mutations;
